// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();

    // Wait for loading to complete
    if (loading) {
        return <div>Loading...</div>;
    }

    // If not logged in, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // if (!allowedRoles.includes(user.role)) {
    //     return <Navigate to="/" />;
    // }

    // return <Outlet />;

    // If logged in, allow access to the route
    return children;
};

export default ProtectedRoute;
